// Copyright The Linux Foundation and each contributor to LFX.
// SPDX-License-Identifier: MIT

export const acsConnectAccountConstants = {
  acsConnectError: 'Something went wrong, please try after sometime.',
  userNotAuthorized:
    'User is not authorized, Please contact to your administrator.',
};
